import React from 'react';
import styled from 'styled-components';
import { useGlobalState } from '../../contexts/GlobalStateContext';

const HeaderContainer = styled.header`
  background: #34574A;
  color: white;
  padding: 16px 32px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const UserName = styled.span`
  font-size: 1rem;
`;

const LogoutButton = styled.button`
  background: white;
  color: #34574A;
  border: none;
  padding: 8px 16px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: bold;
  transition: background 0.3s ease;

  &:hover {
    background: #f5f5f5;
  }
`;

const DashboardHeader = () => {
  const { user, handleLogout } = useGlobalState();

  return (
    <HeaderContainer>
      <Logo>JoviPlanet</Logo>
      <UserInfo>
        <UserName>{user?.name || 'Usuário'}</UserName>
        <LogoutButton onClick={handleLogout}>Logout</LogoutButton>
      </UserInfo>
    </HeaderContainer>
  );
};

export default DashboardHeader;
